import type { SVGProps } from 'react';

const SvgBedOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.84 4.63a.84.84 0 0 1 .839.84v2.424h13.85A2.47 2.47 0 0 1 21 10.366v8.16a.84.84 0 1 1-1.679 0v-1.608H4.68v1.608a.84.84 0 1 1-1.679 0V5.47a.84.84 0 0 1 .84-.839m.839 4.943v5.666h1.585V9.573zm3.264 0v5.666h11.378v-4.873a.793.793 0 0 0-.793-.793z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgBedOutlined;
